<template>
  <div style="display: inline-block">
    <el-button icon="el-icon-picture-outline" @click="exportExcel" v-waves :disabled="hasPerm('export_excel')">{{this.$t('table.export')}}</el-button>
  </div>
</template>
<script>
  import service from '@/utils/server';
  // import axios from "axios";
  // const service = axios.create({
  //   baseURL: "http://127.0.0.1:8081/hd-sz-wds",  // api的base_url
  //   timeout: 5000 // 请求超时时间
  // });

  service.interceptors.request.use(config => {
    let token1 = localStorage.getItem("token_new");
    config.headers.Authorization = token1;
    return config;
  });
  //
  export default {
    components: {},
    data(){
      return{
        paramMap:null
      }
    },
    props:{
      templateName:{type:String,require:true},
      exportName:{type:String,require:true},
      checkParam:{type:Boolean,require:true},
    },
    methods: {
      exportExcel(){
        //
        if(this.checkParam === false){
          return;
        }
        let callbacks = res => {
          this.paramMap = res
        }
        this.$emit('exportParam', {param:'123',callback:callbacks})
        //
        let config = {
          responseType: 'blob',
          timeout: 50000, // 请求超时时间
          headers: {
            'Content-Type': 'application/json'
          }
        };
        var exportVO = {};
        exportVO.templateName = this.templateName;
        exportVO.paramMap = this.paramMap;
        service.post("/excel/export",exportVO,config).then( (res) => {
            if(res.type === "application/json"){
              var blob = new Blob([res])
              var reader = new FileReader();
              reader.readAsText(blob, 'utf-8');
              var that = this;
              reader.onload = function (e) {
                var resp = JSON.parse(reader.result);
                if(resp.code === 200){
                  that.$message({message: resp.msg, type: 'success'});
                }else{
                  that.$message({message: resp.msg, type: 'error'});
                }
              }
            }else if(res.type === "application/vnd.ms-excel"){
              var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
              var downloadElement = document.createElement('a');
              var href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = this.exportName+".xlsx"; //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              this.$message({message: "成功", type: 'success'});
            }
        }).catch(e => {
          this.$message({message: "下载异常，请稍后重试", type: 'error'});
          console.log(e);
        });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/Excel/export.vue